const FAQHero = () => (
  <section className="relative pt-32 pb-16 bg-[#1a2e0d] overflow-hidden">
    <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
      <span className="inline-block bg-[#7ab648]/20 border border-[#7ab648]/30 text-[#a8d96b] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
        Got Questions? We&apos;ve Got Answers.
      </span>
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
        Frequently Asked Questions
      </h1>
      <p className="text-white/60 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
        Everything you need to know about K9 mold detection, before booking, during the detection, and what to do after we&apos;re done.
      </p>
    </div>
  </section>
);

export default FAQHero;